import { DataTable } from "@/components/composables/DataTable";
import { useGetAllPwtTransaction } from "./mutations";
import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";
import useControl from "@/hooks/useControl";
import { useState } from "react";
import moment from "moment";
import Pagination from "./pagination";
import { PTxContent } from "./types";
import Options from "./pwtTransactionOptions";
import ViewPTxModal from "./viewPwtTransactionsModal";

const PwtTransactionTable = () => {
  const {
    state: isOpenView,
    setTrue: onOpenView,
    setFalse: onCloseView,
  } = useControl();

  const [currentPage, setCurrentPage] = useState(1);
  const { data, isPending } = useGetAllPwtTransaction({
    size: 10,
    page: currentPage,
  });

  const [, setTransactionId] = useState("");
  const [transaction, setTransaction] = useState<PTxContent>();
  const totalPages = data?.totalPages as number;

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const columns: ColumnDef<PTxContent>[] = [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          className="border-[#86929E]"
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      header: "Transaction Date",
      cell: ({ row }) => (
        <div>{moment(row.original.receivedDate as string).format("LL")}</div>
      ),
    },
    {
      accessorKey: "customerCode",
      header: "Customer Code",
      cell: ({ row }) => <div>{row.original.customerCode}</div>,
    },
    {
      accessorKey: "terminalId",
      header: "Terminal ID",
      cell: ({ row }) => <div>{row.original.terminalId}</div>,
    },
    {
      header: "Merchant Name",
      cell: ({ row }) => <div>{row.original.merchantName || "N/A"}</div>,
    },
    {
      accessorKey: "amount",
      header: "Amount",
      cell: ({ row }) => (
        <div>
          ₦
          {parseFloat(row.original.requestedAmount)
            .toFixed(2)
            .toLocaleLowerCase()}
        </div>
      ),
    },
    {
      header: "Received Date",
      cell: ({ row }) => (
        <div>{moment(row.original.receivedDate).format("YYYY-MM-DD")}</div>
      ),
    },
    {
      header: "Fee",
      cell: ({ row }) => (
        <div>
          {parseFloat(row.original.fees).toFixed(2).toLocaleLowerCase()}
        </div>
      ),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <Options
          setTransactionId={setTransactionId}
          setTransaction={() => setTransaction(row.original)}
          id={row.original._id}
          onOpenView={onOpenView}
        />
      ),
    },
  ];

  return (
    <div>
      <DataTable
        isLoading={isPending}
        columns={columns}
        data={(data?.pwts ?? []) as PTxContent[]}
      />
      <div className="flex justify-end">
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      {isOpenView && (
        <ViewPTxModal
          onClose={onCloseView}
          transaction={transaction as PTxContent}
        />
      )}
    </div>
  );
};

export default PwtTransactionTable;
